import { FC, useCallback, useState } from "react";
import { Button } from "@shopify/polaris";

import { useAppMutation } from "../../../../../../../hooks/index.js";
import { useAppDispatch } from "../../../../../../../hooks/redux.js";
import { openModal } from "../../../../../../../store/features/modal.js";
import { OPEN_MODAL_UPSELL } from "../../../../../../../constants/modalTypes.js";

export interface SetActiveActionButtonProps {
  actionId: string;
  isActive?: boolean;
  disabled?: boolean;
  onSetAction: (action: any) => void;
}

const SetActiveActionButton: FC<SetActiveActionButtonProps> = ({
  actionId,
  isActive,
  disabled,
  onSetAction,
}) => {
  const dispatch = useAppDispatch();

  const { mutate, isLoading } = useAppMutation({
    url: "/api/action/activate",
    reactMutationOptions: {
      onSuccess: ({ updatedAction }) => {
        onSetAction(prev => prev.map(action => {
          if (action.id === updatedAction.id) {
            return {
              ...action,
              isActive: updatedAction.isActive,
            };
          }
          return action;
        }));
      },
      onError: ((error) => {
        const colectionsCount = error?.colectionsCount;
        const productsCount = error?.productsCount;
        if (!isNaN(colectionsCount) && !isNaN(productsCount)) {
          dispatch(openModal({
            modalType: OPEN_MODAL_UPSELL,
            modalData: {
              limitProductCount: productsCount,
              limitCollectionCount: colectionsCount,
            },
          }));
        }
      }),
    }
  });

  const handleClick = useCallback(() => {
    mutate({ id: actionId, isActive: !isActive });
  }, [actionId, isActive, mutate]);

  const buttonTitle = isActive ? "Deactivate" : "Activate";

  return (
    <Button
      fullWidth
      plain
      primary={!isActive}
      onClick={handleClick}
      loading={isLoading}
      disabled={disabled}
    >
      {buttonTitle}
    </Button>
  );
};

export default SetActiveActionButton;
